const CategoryType = {
  GET_CATEGORIES: 'GET_CATEGORIES',
  GET_CATEGORY: 'GET_CATEGORY',
  CREATE_CATEGORY: 'CREATE_CATEGORY',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
}

export default CategoryType
